<template>
    <share-modal :open="localOpen" @close="$emit('close')" :title="title" :headline="property.name" :snippet="property.headline || property.summary" :link="`https://staymarquis.com/properties/${property.slug}`" @share="shared">
        <card class="bg-light mb-4">
            <card-image v-if="image" :src="image" :background="true" :height="150" />

            <card-body class="flex-grow-1">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <div class="small text-uppercase text-muted" v-if="property.city && property.state">
                        {{ property.city }}, {{ property.state }} {{ (property.country && (property.country != 'US')) ? ', '+property.country : '' }}
                    </div>
                    <div>
                        <property-card-icons v-if="showIcons" :property="property" class="x-small my-3 text-muted" :marginBetween="2" :limited="true"/>
                    </div>
                </div>

                <h5>{{ property.name }}</h5>

                <p v-if="property.headline" class="small">
                    {{ property.headline }}
                </p>
                <p v-else-if="property.summary" class="small">
                    {{ property.summary }}
                </p>
            </card-body>
        </card>
    </share-modal>
</template>

<script type="text/javascript">
    import PropertyCardIcons from '@/components/Content/Public/Properties/Cards/Parts/Icons.vue';
    import ShareModal from '@/components/Content/ShareModal.vue';
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';
    import Api from '@/classes/Api.js';

    export default {
        components: {
            ShareModal,
            PropertyCardIcons,
            ...CommonComponents,
        },

        data() {
            return {
                localOpen: true,
            };
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },

            open: {
                type: Boolean,
                default: true,
            },

            showIcons: {
                type: Boolean,
                default: true,
            },

            title: {
                type: String,
                default: 'Share',
            },
        },

        emits: ['close'],

        created() {
            this.localOpen = this.open;
        },

        watch: {
            open(newVal) {
                this.localOpen = newVal;
            },
        },

        computed: {
            image() {
                if ((this.property) && (this.property.photosList) && (this.property.photosList.length)) {
                    return this.property.photosList[0];
                }

                let firstPhoto;
                if ((this.property) && (this.property.firstPhoto)) {
                    firstPhoto = this.property.firstPhoto;
                }
                else if ((this.property) && (this.property.photos) && (this.property.photos.length)) {
                    firstPhoto = this.property.photos[0];
                }
                if (firstPhoto) {
                    if (firstPhoto.galleryThumbSource) {
                        return firstPhoto.galleryThumbSource;
                    }
                    else if (firstPhoto.cdnImages) {
                        let sizes = ['galleryThumbSource', 'single', 'gallery', 'singleHeader', 'homeaway'];
                        for (let i=0; i<sizes.length; i++) {
                            if (firstPhoto.cdnImages[sizes[i]]) {
                                return firstPhoto.cdnImages[sizes[i]];
                            }
                        }
                    }
                    else if (firstPhoto.gallerySource) {
                        return firstPhoto.gallerySource;
                    }
                }

                return '/img/owner/default-home.jpg';
            },
        },
        
        methods: {
            shared(method) {
                Api.get(`properties/${this.property.id}/shared/${method}`);
            }
        },
    };

</script>
